import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useMemo } from 'react';
const ONE_DAY_IN_SECONDS = 60 * 60 * 24;
const TWO_WEEKS_IN_SECONDS = ONE_DAY_IN_SECONDS * 14;
const makeWithS = (suffix) => (num, name) => {
    const numToDisplay = Math.round(num);
    return `${numToDisplay} ${name}${numToDisplay === 1 ? '' : 's'}${suffix}`;
};
const getRelativeString = (date, nowMs) => {
    const diff = nowMs - date.getTime();
    const seconds = Math.abs(diff / 1000);
    const dayOfWeek = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ][date.getDay()];
    const daySuffix = seconds < TWO_WEEKS_IN_SECONDS && seconds > ONE_DAY_IN_SECONDS ? ` (${dayOfWeek})` : '';
    const withS = makeWithS((diff > 0 ? ' ago' : '') + daySuffix);
    if (seconds < 120) {
        return withS(seconds, 'second');
    }
    const minutes = seconds / 60;
    if (minutes < 90) {
        return withS(minutes, 'minute');
    }
    const hours = minutes / 60;
    if (hours < 48) {
        return withS(hours, 'hour');
    }
    const days = hours / 24;
    if (days < 365) {
        return withS(days, 'day');
    }
    return withS(days / 365, 'year');
};
export const PrettyDate = ({ timestamp, includeTime = true, showRelativeDates, }) => {
    const [nowMs, setNowMs] = useState(() => Date.now());
    useEffect(() => {
        const intervalId = setInterval(() => {
            setNowMs(Date.now());
        }, 30_000);
        return () => {
            clearInterval(intervalId);
        };
    }, []);
    const { absoluteString, relativeString, } = useMemo(() => {
        const date = new Date(timestamp);
        const absoluteString = date.toLocaleDateString() + (includeTime ? ` ${date.toLocaleTimeString()}` : '');
        const relativeString = getRelativeString(date, nowMs);
        return { absoluteString, relativeString };
    }, [includeTime, nowMs, timestamp]);
    return (_jsx("span", { title: showRelativeDates ? absoluteString : relativeString, children: showRelativeDates ? relativeString : absoluteString }));
};
